/**
 * Created by jan on 9-3-15.
 */
// Dutch stopwords
// via https://code.google.com/p/stop-words/



module.exports = {
    stopwords:[
        "aan",
        "af",
        "al",
        "als",
        "bij",
        "dan",
        "dat",
        "die",
        "dit",
        "een",
        "en",
        "er",
        "had",
        "heb",
        "hem",
        "het",
        "hij",
        "hoe",
        "hun",
        "ik",
        "in",
        "is",
        "je",
        "kan",
        "me",
        "men",
        "met",
        "mij",
        "nog",
        "nu",
        "of",
        "ons",
        "ook",
        "te",
        "tot",
        "uit",
        "van",
        "was",
        "wat",
        "we",
        "wel",
        "wij",
        "zal",
        "ze",
        "zei",
        "zij",
        "zo",
        "zou",
        "aan",
        "aangaande",
        "aangezien",
        "achter",
        "achterna",
        "afgelopen",
        "al",
        "aldaar",
        "aldus",
        "alhoewel",
        "alias",
        "alle",
        "allebei",
        "alleen",
        "alsnog",
        "altijd",
        "altoos",
        "ander",
        "andere",
        "anders",
        "anderszins",
        "behalve",
        "behoudens",
        "beide",
        "beiden",
        "ben",
        "beneden",
        "bent",
        "bepaald",
        "betreffende",
        "bij",
        "binnen",
        "binnenin",
        "boven",
        "bovenal",
        "bovendien",
        "bovengenoemd",
        "bovenstaand",
        "bovenvermeld",
        "buiten",
        "daar",
        "daarheen",
        "daarin",
        "daarna",
        "daarnet",
        "daarom",
        "daarop",
        "daarvanlangs",
        "dan",
        "dat",
        "de",
        "die",
        "dikwijls",
        "dit",
        "door",
        "doorgaand",
        "dus",
        "echter",
        "eer",
        "eerdat",
        "eerder",
        "eerlang",
        "eerst",
        "elk",
        "elke",
        "en",
        "enig",
        "enigszins",
        "enkel",
        "er",
        "erdoor",
        "even",
        "eveneens",
        "evenwel",
        "gauw",
        "gedurende",
        "geen",
        "gehad",
        "gekund",
        "geleden",
        "gelijk",
        "gemoeten",
        "gemogen",
        "geweest",
        "gewoon",
        "gewoonweg",
        "haar",
        "had",
        "hadden",
        "hare",
        "heb",
        "hebben",
        "hebt",
        "heeft",
        "hem",
        "hen",
        "het",
        "hierbeneden",
        "hierboven",
        "hij",
        "hoe",
        "hoewel",
        "hun",
        "hunne",
        "ik",
        "ikzelf",
        "in",
        "inmiddels",
        "inzake",
        "is",
        "jezelf",
        "jij",
        "jijzelf",
        "jou",
        "jouw",
        "jouwe",
        "juist",
        "jullie",
        "kan",
        "klaar",
        "kon",
        "konden",
        "krachtens",
        "kunnen",
        "kunt",
        "later",
        "liever",
        "maar",
        "mag",
        "meer",
        "met",
        "mezelf",
        "mij",
        "mijn",
        "mijnent",
        "mijner",
        "mijzelf",
        "misschien",
        "mocht",
        "mochten",
        "moest",
        "moesten",
        "moet",
        "moeten",
        "mogen",
        "na",
        "naar",
        "nadat",
        "net",
        "niet",
        "noch",
        "nog",
        "nogal",
        "nu",
        "of",
        "ofschoon",
        "om",
        "omdat",
        "omhoog",
        "omlaag",
        "omstreeks",
        "omtrent",
        "omver",
        "onder",
        "ondertussen",
        "ongeveer",
        "ons",
        "onszelf",
        "onze",
        "ook",
        "op",
        "opnieuw",
        "opzij",
        "over",
        "overeind",
        "overigens",
        "pas",
        "precies",
        "reeds",
        "rond",
        "rondom",
        "sedert",
        "sinds",
        "sindsdien",
        "slechts",
        "sommige",
        "spoedig",
        "steeds",
        "tamelijk",
        "tenzij",
        "terwijl",
        "thans",
        "tijdens",
        "toch",
        "toen",
        "toenmaals",
        "toenmalig",
        "tot",
        "totdat",
        "tussen",
        "uit",
        "uitgezonderd",
        "vaakwat",
        "van",
        "vandaan",
        "vanuit",
        "vanwege",
        "veeleer",
        "verder",
        "vervolgens",
        "vol",
        "volgens",
        "voor",
        "vooraf",
        "vooral",
        "vooralsnog",
        "voorbij",
        "voordat",
        "voordezen",
        "voordien",
        "voorheen",
        "voorop",
        "vooruit",
        "vrij",
        "vroeg",
        "waar",
        "waarom",
        "wanneer",
        "want",
        "waren",
        "was",
        "weer",
        "weg",
        "wegens",
        "wel",
        "weldra",
        "welk",
        "welke",
        "wie",
        "wiens",
        "wier",
        "wij",
        "wijzelf",
        "zal",
        "ze",
        "zelfs",
        "zichzelf",
        "zij",
        "zijn",
        "zijne",
        "zo",
        "zodra",
        "zonder",
        "zou",
        "zouden",
        "zowat",
        "zulke",
        "zullen",
        "zult"
    ]
};




/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/nl.js
 ** module id = 2960
 ** module chunks = 0
 **/